import { render, staticRenderFns } from "./viewpoint.vue?vue&type=template&id=70411940&scoped=true"
import script from "./viewpoint.vue?vue&type=script&lang=js"
export * from "./viewpoint.vue?vue&type=script&lang=js"
import style0 from "./viewpoint.vue?vue&type=style&index=0&id=70411940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70411940",
  null
  
)

export default component.exports